export default __webpack_public_path__ + "static/icomoon-011d7636d2525aa39da4ea9174bcb93d.woff";